// What a checkout remembers across the trip to Stripe and back, in this tab:
// what was paid (the success page reports it to Google Ads and PostHog) and the
// page the person was on, so paying to take a watermark off leads back to that video.
import { safeRedirect } from './safeRedirect';
import { trackCheckoutStartedConversion } from './analytics';

const KEY = 'checkout_value';
// What an AI video pack and a Clip pack sell for in US$, for a purchase report when neither the API nor
// the trip says (services/packs.py PACK_PRICES, services/local_pricing.py)
export const PACK_VALUE = 5.99;
// A trip to Stripe takes minutes; an entry older than this is another day's
const FRESH_MS = 2 * 60 * 60 * 1000;

export const rememberCheckout = ({ value, currency, billingPeriod = 'monthly', quantity = 1, returnTo, reason }) => {
  // Every checkout passes here on its way to Stripe: Google Ads learns who came close to buying
  trackCheckoutStartedConversion({ value, currency });
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({
      value, currency, billing_period: billingPeriod, quantity,
      return_to: returnTo, reason, at: Date.now(),
    }));
  } catch {
    // no storage: the success page reports the default and offers its usual buttons
  }
};

/** The remembered checkout, once: {value, currency, returnTo, reason, ...} or {}. */
export const takeCheckout = (now = Date.now()) => {
  try {
    const kept = JSON.parse(window.sessionStorage.getItem(KEY) || '{}');
    window.sessionStorage.removeItem(KEY);
    const fresh = !kept.at || now - kept.at < FRESH_MS;
    // Only a page of this site, and never the pricing or checkout pages themselves
    const path = fresh && kept.return_to ? safeRedirect(kept.return_to) : null;
    const returnTo = path && path !== '/' && !/^\/([a-z]{2}\/)?(pricing|precios|precos|subscription)\b/.test(path) ? path : null;
    return { ...kept, returnTo };
  } catch {
    return {};
  }
};
